export default {
  logging: 'Iniciando sesión...',
  logCall: 'Registrar llamada',
  editLog: 'Editar registro',
  select: 'Seleccionar una grabación que coincida',
  OnHold: 'En espera',
  Ringing: 'Llamando',
  CallConnected: 'Llamada conectada',
  unknownUser: 'Usuario desconocido',
  unknownNumber: 'Anónimo',
  unavailable: 'No disponible',
  viewDetails: 'Ver detalles',
  'phoneSource.systemUser': '(Usuario del sistema)',
  'phoneSource.account': '(Cuenta)',
  'phoneSource.contact': '(Contactos)',
  'phoneSource.lead': '(Posible cliente)',
  'phoneSource.opportunity': '(Candidato a posible cliente)',
  'phoneType.phone': '(Teléfono)',
  'phoneType.home': '(Teléfono fijo)',
  'phoneType.business': '(Teléfono del trabajo)',
  'phoneType.mobile': '(Teléfono móvil)',
  'phoneType.unknown': '(Tipo de teléfono desconocido)',
};
